var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rc-section-background default"},[_c('img',{staticClass:"default-background initial loading",attrs:{"src":_vm.imageUrl,"data-was-processed":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }